export const isTrue = (str: string) => str === "true";

// block user to swipe forewards & backwards in browser
export const disableUserToSwipePage = (active: boolean) =>
  (document.body.style.overscrollBehaviorX = active ? "none" : "initial");

export function deepClone(object: any) {
  return JSON.parse(JSON.stringify(object));
}

export { default as capitalize } from "./capitalize";
export * from "./date";
export * from "./file";
export * from "./filterList";
export * from "./input";
export * from "./regex";
export { default as reportWebVitals } from "./reportWebVitals";
export { default as scrollTop } from "./scrollTop";
export { default as textOrUnknown } from "./textOrUnknown";
